import React from "react";

export function Error() {
  return (
    <div>Page not found</div>
  )
}
